import React from 'react'

const Hero = () => {
  return (
    <div className='mainbg-color text-center  p-3 '>
        <p className='text-primary lh-sm' style={{fontSize: '10px'}}>1% OF THE INDUSTRY</p>
        <p className='lh-sm mx-4 px-2' style={{fontSize: "50px", fontWeight: 'bold'}}>Hype got you here. <br />Stay for the support.</p>
        <p className='fs-5 mx-4 px-2'>We’ve been told it is possible to revolutionize the payment industry. We have not reinvented the wheel, we decided to build upon it - successfully.</p>
    </div>
  )
}

export default Hero